import { useEffect } from "react";
import { usePostContext } from "../context/PostContext";
import useAuth from "./useAuth";
import useAxiosPrivate from "./usePrivate";

export default function usePosts() {
    const { isLoggedIn } = useAuth();
    const axiosPrivateInstance = useAxiosPrivate();

    const { posts, setPosts, loading, setLoading, error, setError } = usePostContext(); // Use context

    async function getPosts() {
        if (!isLoggedIn) {
            return;
        }

        setLoading(true);
        setError(null);

        try {
            const { data } = await axiosPrivateInstance.get('blog/posts/');
            setPosts(data);
        } catch (error) {
            console.error("Error fetching posts:", error.response);
            if (error.response?.status === 404) {
                setError('Posts not found');
            } else {
                setError(error.response?.data || "An error occurred while fetching posts.");
            }
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (isLoggedIn) {
            getPosts();
        }
    }, [isLoggedIn]);

    return { posts, loading, error, getPosts };
}
